<template>
  <div class="subscription-box" :class="{ 'premium-box': isPremium }">
    <div class="subscription-content">
      <div class="badge-container">
        <span v-if="isPopular" class="popular-badge">PALING POPULER</span>
      </div>
      
      <div class="plan-header">
        <h3 class="plan-title">{{ title }}</h3>
        <div class="price-container">
          <span class="price">{{ price }}</span>
        </div>
        <p class="description">{{ description }}</p>
      </div>

      <div class="features-list">
        <ul>
          <li v-for="(feature, index) in features" :key="index">
            <span class="check-icon">✓</span>
            <span class="feature-text">{{ feature }}</span>
          </li>
        </ul>
      </div>

      <button @click="handleButtonClick" class="subscribe-button" :class="{ 'premium-button': isPremium }">
        {{ isPremium ? 'Berlangganan Sekarang' : 'Mulai Berlangganan' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "LanggananBox",
  props: {
    title: {
      type: String,
      required: true
    },
    price: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    features: {
      type: Array,
      default: () => []
    },
    link: {
      type: String,
      required: true
    },
    isPopular: {
      type: Boolean,
      default: false
    },
    isPremium: {
      type: Boolean,
      default: false
    },
    planId: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleButtonClick() {
      const token = localStorage.getItem('token');
      
      if (!token) {
        // Jika belum login, emit subscription-error untuk menampilkan form login
        this.$emit('subscription-error', {
          status: 401,
          message: 'Silakan login terlebih dahulu untuk berlangganan'
        });
        return;
      }
      
      // Check if token is expired
      try {
        const tokenData = JSON.parse(atob(token.split('.')[1]));
        const now = Math.floor(Date.now() / 1000);
        
        if (tokenData.exp < now) {
          // Token expired
          localStorage.removeItem('token');
          this.$emit('subscription-error', {
            status: 401,
            message: 'Sesi Anda telah berakhir, silakan login ulang'
          });
          return;
        }
      } catch (error) {
        // Invalid token format
        localStorage.removeItem('token');
        this.$emit('subscription-error', {
          status: 401,
          message: 'Sesi login tidak valid, silakan login ulang'
        });
        return;
      }
      
      // Jika sudah login dan token valid, emit button-click untuk menampilkan payment modal
      this.$emit('button-click');
    },

    loadMidtransScript() {
      return new Promise((resolve, reject) => {
        if (window.snap) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = process.env.VUE_APP_MIDTRANS_IS_PRODUCTION
          ? 'https://app.midtrans.com/snap/snap.js'
          : 'https://app.sandbox.midtrans.com/snap/snap.js';
        script.setAttribute('data-client-key', process.env.VUE_APP_MIDTRANS_CLIENT_KEY);
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    }
  }
};
</script>

<style scoped>
.subscription-box {
  background: #ffffff;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid #eaeaea;
}

.subscription-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.premium-box {
  background: linear-gradient(145deg, #ffffff 0%, #f8f9ff 100%);
  border: 2px solid #6366f1;
  transform: scale(1.02);
}

.premium-box:hover {
  transform: scale(1.03) translateY(-5px);
}

.subscription-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.badge-container {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
}

.popular-badge {
  background: #6366f1;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.plan-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.plan-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
}

.price-container {
  margin: 1rem 0;
}

.price {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1f2937;
}

.description {
  color: #6b7280;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 1rem 0;
}

.features-list {
  flex-grow: 1;
  margin: 1.5rem 0;
}

.features-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.features-list li {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  color: #4b5563;
}

.check-icon {
  color: #6366f1;
  font-weight: bold;
  margin-right: 0.75rem;
}

.feature-text {
  font-size: 0.95rem;
}

.subscribe-button {
  width: 100%;
  padding: 1rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #488e71;
  color: white;
  border: none;
  margin-top: auto;
}

.subscribe-button:hover {
  background: #3a7259;
  transform: translateY(-2px);
}

.premium-button {
  background: #6366f1;
}

.premium-button:hover {
  background: #4f46e5;
}

@media (max-width: 768px) {
  .subscription-box {
    padding: 1.5rem;
  }

  .plan-title {
    font-size: 1.25rem;
  }

  .price {
    font-size: 1.5rem;
  }

  .description {
    font-size: 0.9rem;
  }

  .feature-text {
    font-size: 0.9rem;
  }
}
</style>
